<div class="max-w-7xl mx-auto p-8">
  <!-- POC Warning -->
  <div class="bg-amber-50 border border-amber-300 rounded-lg p-4 mb-6">
    <div class="flex items-start gap-3">
      <mat-icon class="text-amber-600 !text-2xl !w-6 !h-6 !leading-6">
        warning
      </mat-icon>
      <div>
        <h3 class="font-semibold text-amber-900 text-sm">Proof of Concept</h3>
        <p class="text-sm text-amber-800">
          This page is a proof of concept and requires UX work before deploying.
        </p>
      </div>
    </div>
  </div>

  <!-- Welcome Header -->
  <div class="mb-8">
    <h1 class="text-3xl font-bold text-gray-900 mb-2">
      Welcome back, {{ userName }}
    </h1>
  </div>

  <!-- Quick Actions Grid -->
  <div class="mb-8">
    <h2 class="text-xl font-semibold text-gray-900 mb-4">Quick Actions</h2>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      @for (action of visibleActions; track action.route) {
        <button
          (click)="navigate(action.route)"
          class="bg-white border border-gray-200 rounded-lg p-6 hover:border-blue-500 hover:shadow-md transition-all text-left group">
          <div class="flex items-start gap-4">
            <div class="bg-blue-50 rounded-lg p-3 group-hover:bg-blue-100 transition-colors">
              <mat-icon class="text-blue-600 !text-2xl !w-6 !h-6 !leading-6">
                {{ action.icon }}
              </mat-icon>
            </div>
            <div class="flex-1">
              <h3 class="font-semibold text-gray-900 mb-1 group-hover:text-blue-600 transition-colors">
                {{ action.title }}
              </h3>
              <p class="text-sm text-gray-600">
                {{ action.description }}
              </p>
            </div>
          </div>
        </button>
      }
    </div>
  </div>

  <!-- Getting Started -->
  <div class="bg-blue-50 border border-blue-200 rounded-lg p-6">
    <div class="flex items-start gap-4">
      <mat-icon class="text-blue-600 !text-[32px] !w-8 !h-8 !leading-8">
        info
      </mat-icon>
      <div>
        <h3 class="font-semibold text-gray-900 mb-2">Getting Started</h3>
        <p class="text-sm text-gray-700 mb-3">
          Use the navigation on the left to access different areas of the system, or click one of the quick actions above to get started.
        </p>
        <ul class="text-sm text-gray-700 space-y-1 list-disc list-inside">
          <li>Configure locker banks and assign lockers</li>
          <li>Manage staff credentials and access</li>
          <li>Monitor system metrics and performance</li>
        </ul>
      </div>
    </div>
  </div>
</div>
